module.exports = __webpack_public_path__ + "img/icon-win1.6538fc71.svg";